import { Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import {
  NotificationBar,
  NotificationsProvider,
} from "./components/Notification";
import TopBar from "./components/TopBar";
import GlobalContext from "./global-context";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("user") ? true : false
  );
  const [currency, setCurrency] = useState(
    localStorage.getItem("currency") || "USD"
  );

  return (
    <BrowserRouter>
      <GlobalContext.Provider value={globalStateValues()}>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <NotificationsProvider>
            <TopBar />
            <Box
              sx={{
                maxWidth: "1300px",
                mx: "auto",
                mt: "84px",
                mb: "100px",
                px: "10px",
              }}
            >
              <Routes />
            </Box>
            <NotificationBar />
          </NotificationsProvider>
        </LocalizationProvider>
      </GlobalContext.Provider>
    </BrowserRouter>
  );

  function globalStateValues() {
    return { loggedIn, setLoggedIn, currency, setCurrency };
  }
}
